class TextScrolling extends HTMLElement {  
    constructor() {
      super();
      this.triger
      this.imageWrapper = this.querySelector('.text-scrolling__wrapper');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.textItems = this.querySelectorAll('.text-scrolling__timeline-item');

      this.openPopupBtn = this.querySelector('.js-info-slider__open-popup');
      this.popup = this.querySelector('.js-info-slider__popup');
      this.popupOverlay = this.querySelector('.js-info-slider__popup-overlay');
      this.closePopupBtn = this.querySelector('.js-info-slider__popup-close');

      this.openPopupBtn?.addEventListener('click', this.handleOpenPopup);
      this.closePopupBtn?.addEventListener('click', this.handleClosePopup);
      this.popupOverlay?.addEventListener('click', this.handleClosePopup);

      if(this.imageWrapper && this.progressBar){
        this.init();
      }
    }

    handleOpenPopup = ()=> {
        this.popup?.classList.add('is-open');
    }

    handleClosePopup = ()=> {
    this.popup?.classList.remove('is-open');
    }
    
    init(){
        window.addEventListener('scroll',()=>{
            this.renderProgresBar();
            this.renderTextBlocks();
            this.setImageHeight();
        })
        
        document.addEventListener('DOMContentLoaded',()=>{
            setTimeout(()=>{
                window.dispatchEvent(new Event('scroll'));
            },1000)
        })
    }

    renderTextBlocks(){
        if(this.textItems.length){
            this.textItems.forEach((item)=>{
                let isVisible = this.isElementPastMiddleOfScreen(item);

                if(isVisible){
                    item.classList.add('is-visible');
                }else{
                    item.classList.remove('is-visible');
                }
            })
        }
    }

    renderProgresBar(){
        let firstElement = this.querySelectorAll('.text-scrolling__timeline-item.is-visible')[0];

        if(firstElement){
            let y = this.getDistanceToScreenCenter(firstElement);
            y = Math.abs(y);
            this.progressBar.style.height = `${y}px`
        }

        if(!this.querySelector('.text-scrolling__timeline-item.is-visible')){
            this.progressBar.style.height = '0px';
        }
    }

    isElementPastMiddleOfScreen(element) {
        const rect = element.getBoundingClientRect();
        const screenMiddle = window.innerHeight / 2;      
        return rect.top <= screenMiddle;
    }

    getDistanceToScreenCenter(element) {
        const rect = element.getBoundingClientRect();      
        const screenMiddle = window.innerHeight / 2;
        const elementTop = rect.top;
      
        const distance = elementTop - screenMiddle;
        return distance;
    }


    setImageHeight(){
        let img = this.imageWrapper.querySelector('img');
        let imageHeight = img.clientHeight;

        img.style.setProperty('--image-height', `${imageHeight}px`);
    }
}
  
  customElements.define("text-scrolling", TextScrolling);
  